export const DEFAULT_QUERY_LIMIT = 100;
export const DEFAULT_PAGE = 0;
export const MAX_RELATED_QUERY_LIMIT = 500;
